export default __webpack_public_path__ + "static/media/exclamation.5ee2bd7b.svg";